import { render } from "./ProductGiftItem.vue?vue&type=template&id=d2e39582&scoped=true&lang=pug"
import script from "./ProductGiftItem.vue?vue&type=script&lang=js"
export * from "./ProductGiftItem.vue?vue&type=script&lang=js"

import "./ProductGiftItem.vue?vue&type=style&index=0&id=d2e39582&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2e39582"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QChip,QSeparator,QItem,QBtn});
